module.exports = __webpack_public_path__ + "img/SES_191428802.8f2663e7.jpg";